import createAbsolutePath from "createAbsolutePath";

const getJoorReactAssortmentUrl = (assortmentId: string) =>
  createAbsolutePath(`/assortments/get_assortment/${assortmentId}`);

export default getJoorReactAssortmentUrl;
